import React, { Fragment } from 'react';
import KickImage from 'Reuseables/KickImage';
import { ModalLoginNew, ModalNotVerified, ModalSentVerifyEmailDone, ModalOutOfStock, ModalAlert } from '../Modals';
import { Button } from '../Forms';
import propTypes from 'prop-types';
import ModalUnverifiedUser from 'Pages/Home/Components/Organisms/ModalUnverifiedUser/ModalUnverifiedUser';

const RenderTag = ({ children, childrenFunc, tag }) => {
  const CustomTag = `${tag}`
  return childrenFunc ? <Fragment>{children}</Fragment> :
    <CustomTag className="protected-wrapper">{children}</CustomTag>
}

const withVerifiedUser = (WrappedComponent) => {
  return class extends React.Component {
    constructor(props) {
      super(props);
      this.state = {
        toggleLogin: false,
        toggleNotVerifiedInfo: false,
        toggleSentVerifiedDone: false,
        toggleIsNotApparel: false,
        toggleAlertModal: false
      }
      this._onToggleLoginModal = this._onToggleLoginModal.bind(this);
      this._onToggleNotVerifiedInfoModal = this._onToggleNotVerifiedInfoModal.bind(this);
      this._onToggleSentVerifiedDoneModal = this._onToggleSentVerifiedDoneModal.bind(this);
      this._onToggleIsNotApparelModal = this._onToggleIsNotApparelModal.bind(this);
      this._onToggleAlertModal = this._onToggleAlertModal.bind(this);
    }

    _onToggleNotVerifiedInfoModal() {
      this.setState({ toggleNotVerifiedInfo: !this.state.toggleNotVerifiedInfo });
    }

    _onToggleLoginModal() {
      this.setState({ toggleLogin: !this.state.toggleLogin });
    }

    _onToggleSentVerifiedDoneModal() {
      this.setState({ toggleSentVerifiedDone: !this.state.toggleSentVerifiedDone });
    }

    _onToggleIsNotApparelModal() {
      this.setState({ toggleIsNotApparel: !this.state.toggleIsNotApparel });
    }

    _onToggleAlertModal() {
      this.setState({ toggleAlertModal: !this.state.toggleAlertModal });
    }

    _render() {
      const { childrenFunc, onClick, roleNotAlloweds, countryCodeAllowed, isLogged, userData, children, isCarousel, redirectTo, history, tag = "div", ...rest } = this.props;
      if (isLogged === true) {
        const roles = userData.roles || [];
        const userNotAllowed = roles.length > 0 && roles.filter(role => {
          const filterd = roleNotAlloweds.filter(not => not === role);
          return filterd.length;
        }).length

        //role validation
        if (!roles.includes('seller_apparel') && this.props.buttonText === "SELL") {
          if (this.props.category && this.props.category.toLowerCase() === "apparels") {
            return (
              <RenderTag childrenFunc={childrenFunc} tag={tag}>
                <ModalOutOfStock
                  isCloseable={true}
                  isOpen={this.state.toggleIsNotApparel}
                  message="You have not registered as Apparel Seller yet."
                  buttonPrimaryText={"BACK TO PRODUCT"}
                  onButtonPrimaryClick={this._onToggleIsNotApparelModal}
                />
                {
                  childrenFunc ?
                    childrenFunc({ ...this.props, onClick: this._onToggleIsNotApparelModal })
                    :
                    <Button
                      {...rest}
                      onClick={this._onToggleIsNotApparelModal}
                    />
                }
              </RenderTag>
            )
          }
        }

        //country validation 


        if (countryCodeAllowed && countryCodeAllowed.length > 0) {
          // const countrySeller = userData && userData.user_setting && userData.user_setting.seller_location && userData.user_setting.seller_location.country_id
          const countryId = userData && userData.country_code;

          if (countryId && ~countryCodeAllowed.indexOf(countryId)) {
            // console.log("test - allowed country")
          }
          else {
            return (
              <RenderTag childrenFunc={childrenFunc} tag={tag}>
                <ModalAlert
                  isOpen={this.state.toggleAlertModal}
                  contentText={"Sorry, this features is not available yet on your country."}
                  showButton={false}
                  onToggle={this._onToggleAlertModal}
                />
                {
                  childrenFunc ?
                    childrenFunc({ ...this.props, onClick: this._onToggleAlertModal })
                    :
                    <Button
                      {...rest}
                      onClick={this._onToggleAlertModal}
                    />
                }
              </RenderTag>
            )
          }
        }

        if (userNotAllowed) {
          return (
            <RenderTag childrenFunc={childrenFunc} tag={tag}>
              <ModalUnverifiedUser isHome isShow={this.state.toggleNotVerifiedInfo} setIsShow={this._onToggleNotVerifiedInfoModal} />
              <ModalSentVerifyEmailDone
                isOpen={this.state.toggleSentVerifiedDone}
                onToggle={this._onToggleSentVerifiedDoneModal}
                email={userData.typed_email ? userData.typed_email : userData.email}
              />
              {
                childrenFunc ?
                  childrenFunc({ ...this.props, onClick: this._onToggleNotVerifiedInfoModal })
                  :
                  <Button
                    {...rest}
                    onClick={this._onToggleNotVerifiedInfoModal}
                  />
              }
            </RenderTag>
          )
        }
        return <WrappedComponent {...rest} children={children} childrenFunc={childrenFunc} onClick={onClick} />
      }
      else {
        return (
          <RenderTag childrenFunc={childrenFunc} tag={tag}>
            <ModalLoginNew
              // navigation = { this.props.navigation }
              // location={this.props.navigation.location}
              isOpen={this.state.toggleLogin}
              onClosed={() => this.setState({ toggleLogin: false })}
              history={history}
              redirectTo={redirectTo}
            />
            {
              isCarousel ?
                <WrappedComponent {...rest} children={children} onClick={this._onToggleLoginModal} />
                :
                childrenFunc ?
                  childrenFunc({ ...this.props, onClick: this._onToggleLoginModal, status: "login" })
                  :
                  <Button
                    {...rest}
                    onClick={this._onToggleLoginModal}
                    children={children}
                  />
            }
          </RenderTag>
        )
      }
    }
    render() {
      return this._render();
    }
  }
}
export default withVerifiedUser;

withVerifiedUser.propTypes = {
  isLogged: propTypes.bool.isRequired,
  userData: propTypes.objectOf({
    roles: propTypes.array.isRequired
  }).isRequired,
  roleNotAlloweds: propTypes.array.isRequired,
  category: propTypes.string
}

withVerifiedUser.defaultProps = {
  isLogged: false,
  category: 'sneakers'
}